module.exports = __webpack_public_path__ + "static/media/wallet_green_badge.f177152c.svg";